import { withInstall } from '@chenms-zj/utils/with-install'
import _Progress from './src/progress.vue'

export const Progress = withInstall(_Progress)
export default Progress

export * from './src/progress'

// 声明模块
declare module 'vue' {
  export interface GlobalComponents {
    'cms-progress': typeof Progress
  }
}